var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PMain',{attrs:{"dataKey":_vm.key},model:{value:(_vm.themeData),callback:function ($$v) {_vm.themeData=$$v},expression:"themeData"}},[_c('OrderCompleteDialog',{attrs:{"themeData":_vm.themeData},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }